<template>
    <v-select
        v-model="selected"
        :items="items"
        :label="label"
        @input="run"
        menu-props="offset-y, offset-overflow"
        :outlined="outlined"
        :hide-details="hideDetails"
        :alvqa="alvqa"
        :clearable="clearable"
        :no-data-text="$t('lang_GENERAL_CAPTION_NO_DATA_AVAILABLE')"
        :return-object="returnObject"
        :item-text="itemText"
        :item-value="itemValue"
        @click:clear="resetVal()"
    >
        <template v-slot:item="{ item }">
            <div :alvqa="item.alvqa">
                {{ item.text }}
            </div>
        </template>
        <template v-slot:selection="{ item }">
            <div class="text-no-wrap text-truncate" :alvqa="item.alvqa">
                {{ item.text }}
            </div>
        </template>
    </v-select>
</template>

<script>
import VSelect from 'vuetify/es5/components/VSelect'

export default {
    name: "BaseDropdown",
    extends: VSelect,
    props: {
        context: String,
        hideDetails: Boolean,
        alvqa: {
            type: String,
            default: ''
        },
        returnObject: {
            type: Boolean,
            default: false
        },
        clearable: {
            type: Boolean,
            default: false
        },
        itemValue: {
            type: String | Function,
            default: "value"
        },
        itemText: {
            type: String | Function,
            default: "text"
        },
        resetOnSelect: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        selected: {
            get() { return this.$store.getters['getSelected'+this.context] },
            set(selectedAction) { this.$store.commit('setSelected'+this.context, selectedAction) }            
        },
    },
    methods: {
        run() {
            if(this.$store._actions['do'+this.context]){
                this.$store.dispatch('do'+this.context)
            }
            if (this.resetOnSelect === true) {
                this.resetVal()
            }
            // if(this.$store._mutations['setSelected' + this.context]) {
            //     console.log(this.selected)
            //     if(this.selected !== 'archiveWithForwarded' && this.selected !== 'archiveWithoutForwarded') {
            //         this.$store.commit('setSelected' + this.context , [])
            //     }
            // }
        },
        async resetVal() {
            await this.$nextTick()
            this.selected = null
        }
    }
}
</script>